<template>
    <a-form >
      <a-form-item label="送红包" required>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-input v-model:value="bonus.bonus_content" readonly />
          </a-col>
          <a-col :span="12">
             <a-button type="primary" @click="showRed=true">
              选择
            </a-button>
          </a-col>
        </a-row>
        <div style="border:1px dashed #f04635;line-height:2" class="s_flex_ali p-t-5 p-l-5 p-b-5 p-r-10  m-t-10 width80">
            <InfoCircleOutlined class="m-r-10"/>
            <div> 为避免红包零钱发放失败,请确保红包零钱余额充足,查看余额或充值,请前往<a href="/businessCenter/account" target="_blank">商户中心</a></div>
        </div>
      </a-form-item>
    </a-form>
     <a-modal  :keyboard="false" title="选择红包" v-model:visible="showRed" centered :width='1200' :footer="null" destroyOnClose>
    <selectBouns v-on:select="redSelect"  :checkout='false'></selectBouns>
  </a-modal>
</template>
<script>
import { onMounted, ref } from "vue";
import { InfoCircleOutlined} from "@ant-design/icons-vue";
export default {
  components:{InfoCircleOutlined},
  name: "isBonus",
  props:{
    bonus_id:String,
    bonus_content:String
  },
  setup(props, { emit }) {
    const bonus = ref({});
    const onchange = (e) => {
      emit("update:value", e.id);
      emit("update:content", e.amount+`(${e.bonus_type_text})`);
    };
    onMounted(()=>{
      if(props.bonus_id){
        bonus.value={
        bonus_id:props.bonus_id,
        bonus_content:props.bonus_content
        }
      }
    })

    const showRed=ref(false)
    const redSelect=(data)=>{
      onchange(data)
      bonus.value={
        bonus_id:data.id,
        bonus_content:data.amount+`(${data.bonus_type_text})`
      }
      showRed.value=false
    }
    return {
      bonus,
      onchange,
      showRed,
      redSelect
    };
  },
};
</script>